import { CopyKey } from '../../../i18n';

export const WNW_BANNER_SIGN_UP_COPY_KEYS = [
    'wnw_flow.banner.list.approve',
    'wnw_flow.banner.list.benefits',
    'wnw_flow.banner.list.premium_clients',
    'wnw_flow.banner.list.commission_free',
] satisfies CopyKey[];

export const WNW_BANNER_SIGN_IN_COPY_KEYS = [
    'wnw_flow.banner.list.premium_clients',
    'wnw_flow.banner.list.commission_free',
] satisfies CopyKey[];
